import {
  DEFAULT_ADDRESS_LINE_ORDER,
  getAddressFieldSetting,
  hasAddressFieldData,
  isHiddenAddressField,
} from "./addressModel";

export const BASE_COMPARE_FIELDS = [
  "companyName",
  "orgNo",
  "vatNumber",
  "contactPerson",
  "email",
  "telephone",
];

export const ADDRESS_COMPARE_FIELDS = [
  "name",
  "address1",
  "address2",
  "address3",
  "address4",
  "address5",
  "zip",
  "city",
  "country",
  "contact",
  "reference",
  "email",
  "telephone",
];

export const BILLING_COMPARE_FIELDS = [
  "paymentMethod",
  "paymentTermsDays",
  "distributionType",
  "invoiceEmail",
  "currencyCode",
];

export const normalizeComparisonValue = (value) =>
  String(value ?? "")
    .trim()
    .replace(/\s+/g, " ")
    .toLocaleLowerCase("sv");

export const hasMasterValue = (value) =>
  value !== undefined && value !== null && String(value).trim() !== "";

export const differsFromOrganization = (customerValue, organizationValue) =>
  organizationValue !== undefined &&
  organizationValue !== null &&
  normalizeComparisonValue(customerValue) !== normalizeComparisonValue(organizationValue);

const arraysEqual = (left, right) => {
  const a = left || [];
  const b = right || [];
  return a.length === b.length && a.every((value, index) => value === b[index]);
};

export const isAddressFieldSettingOverride = (address, baselineAddress, fieldKey) => {
  if (!baselineAddress) return false;

  const current = getAddressFieldSetting(address, fieldKey);
  const master = getAddressFieldSetting(baselineAddress, fieldKey);

  return (
    current.type !== master.type ||
    normalizeComparisonValue(current.label) !== normalizeComparisonValue(master.label) ||
    normalizeComparisonValue(current.placeholder) !== normalizeComparisonValue(master.placeholder)
  );
};

export const countChangedFields = (draft, baseline, fields) =>
  baseline ? fields.filter((field) => differsFromOrganization(draft?.[field], baseline?.[field])).length : 0;

export const countBaseOverrides = (draft, baseline) =>
  countChangedFields(draft, baseline, BASE_COMPARE_FIELDS);

export const countBillingOverrides = (draft, baseline) =>
  countChangedFields(draft, baseline, BILLING_COMPARE_FIELDS);

export const getAddressOverrideDetails = (address, baselineAddress) => {

  

  if (!baselineAddress) {
    return { fieldCount: 0, settingCount: 0, orderChanged: false, hiddenDataCount: 0, total: 0 };
  }

  const fieldCount = ADDRESS_COMPARE_FIELDS.filter((field) =>
    differsFromOrganization(address?.[field], baselineAddress?.[field])
  ).length;

  const settingCount = DEFAULT_ADDRESS_LINE_ORDER.filter((field) =>
    isAddressFieldSettingOverride(address, baselineAddress, field)
  ).length;

  const orderChanged = !arraysEqual(address?.lineOrder, baselineAddress?.lineOrder);

  const hiddenDataCount = (address?.lineOrder || []).filter(
    (field) => isHiddenAddressField(address, field) && hasAddressFieldData(address, field)
  ).length;

  return {
    fieldCount,
    settingCount,
    orderChanged,
    hiddenDataCount,
    total: fieldCount + settingCount + (orderChanged ? 1 : 0),
  };
};

export const countAddressOverrides = (draft, baseline) => {
  if (!baseline?.id) return 0;
  

  const billing = getAddressOverrideDetails(draft.billingAddress, baseline.billingAddress);
  const delivery = draft.deliverySameAsBilling
    ? { total: 0 }
    : getAddressOverrideDetails(draft.deliveryAddress, baseline.deliveryAddress);

  const sameAsBillingChanged =
    typeof baseline.deliverySameAsBilling === "boolean" &&
    draft.deliverySameAsBilling !== baseline.deliverySameAsBilling;

  return billing.total + delivery.total + (sameAsBillingChanged ? 1 : 0);
};

export const countLogoOverrides = (draft, baseline) =>
  baseline?.logoUrl && (draft.logoDataUrl || draft.logoHidden) ? 1 : 0;

export const getTotalOrganizationOverrideCount = (draft, baseline) =>
  countBaseOverrides(draft, baseline) +
  countAddressOverrides(draft, baseline) +
  countBillingOverrides(draft, baseline) +
  countLogoOverrides(draft, baseline);